<template>
  <div class="switch_wrap">
    <div class="study_header">
      <div class="logo">
        <img src="/static/images/logo_new.png" alt="">
      </div>
      <div class="course_title">
        <p :title="courseName">{{courseName}}</p>
      </div>
      <div class="class_name" :title="$route.query.className">{{$route.query.className?'班级：':''}}{{$route.query.className}}</div>
      <div class="login-user">
        <el-dropdown @command="handleCommand" :show-timeout="0">
          <div class="user-name el-dropdown-link">
              <div class="imgBox">
                <img :src="imgUrl">
              </div>
              <div class="login-name" :title="name">{{name}}</div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="d">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="tab_list_preview">统计</div>
    </div>
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
  import * as api from '@/api/courseApi'
  export default {
    name: "switchpage",
    data(){
      return{
        imgUrl:'/static/images/hed0.png',
        name:'',
        courseName: '',
        routerArr: [],
      }
    },
    mounted() {
      this.getRouterArr();
      window.addEventListener('beforeunload', e => this.beforeunloadHandler(e))
    },
    destroyed() {
      window.removeEventListener('beforeunload', e => this.beforeunloadHandler(e))
    },
    methods:{
      // 记录用户在课程页面停留多长时间
      beforeunloadHandler(e){
        let time = new Date().getTime();
        if (this.$route.meta.time &&  time - this.$route.meta.time > 5*1000) {
          let data = {
            ext: '测试',
            "endTime": time,
            "routeUrl": process.env.BASE_API + this.$route.fullPath,
            "startTime": Number(this.$route.meta.time),
            "time": Math.ceil((time - this.$route.meta.time) / 1000),
            "userId": window.sessionStorage.getItem('userId')
          }
          api.endVideo(data).then(()=>{})
        }
        return
      },
      getRouterArr(){
        this.courseName = this.$route.query.courseName
        this.name = this.$store.state.loginName? this.$store.state.loginName : sessionStorage.getItem('loginName');
        this.routerArr = [ { name: "统计", path: "/switch/statistics" } ]
      },
      handleCommand(command){
        if(command == 'd'){
          this.$logOut()
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .switch_wrap{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    .study_header{
      height: 56px;
      width: 100%;
      background: #1D70E2;
      .logo{
        width: 280px;
        float: left;
        img{
          height: 38px;
          margin: 9px 0 0 16px
        }
      }
      .course_title{
        float: left;
        p{
          max-width: 250px;
          overflow: hidden;
          line-height: 56px;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size:14px;
          font-weight:400;
          color:rgba(255,255,255,1);
        }
      }
      .class_name {
        float: left;
        max-width: 250px;
        overflow: hidden;
        line-height: 56px;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size:14px;
        font-weight:400;
        color:rgba(255,255,255,1);
        margin-left: 30px;
      }
      .tab_list{
        float: right;
        margin-right: 15px;
        ul{
          display: flex;
          margin-top: 14px;
          li{
            width: 60px;
            height: 28px;
            font-size:14px;
            font-weight:400;
            color:rgba(255,255,255,1);
            box-sizing: border-box;
            border-radius: 4px;
            text-align: center;
            line-height: 28px;
            cursor: pointer;
          }
          .active{
            border: 1px solid #fff;
          }
        }
      }
      .login-user {
        float: right;
        position: relative;
        cursor: pointer;
        .login-name {
          margin-left: 6px;
          color: #fff;
          line-height: 20px;
        }
        .user-name {
          height: 56px;
          display: flex;
          align-items: center;
          .imgBox {
            width: 30px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            border: 1px solid #333;
            border-radius: 50%;
            img{
              height: 100%;
            }
          }
        }
        .el-dropdown {
          margin-right: 22px;
        }
        &:hover{
          .login-name {
            color: #333;
          }
        }
      }
      .tab_list_preview{
        float: right;
        width: 60px;
        height: 28px;
        font-size:14px;
        font-weight:400;
        color:rgba(255,255,255,1);
        box-sizing: border-box;
        border-radius: 4px;
        text-align: center;
        line-height: 28px;
        cursor: pointer;
        border: 1px solid #fff;
        margin-right: 20px;
        margin-top: 14px;
      }
    }
    main{
      width: 100%;
      height: calc(100% - 56px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/szrt_revision/new_educa_module/educa/classStatistics/statisticsPage.vue